import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { sportIds } from 'src/constants/personalizationIds'
import { latinoPlanData } from 'src/constants/planData/latinoPlanData'
import { usPlanData } from 'src/constants/planData/usPlanData'
import styled from 'styled-components'
import { Link } from 'gatsby'

export default (props) => {
  return (
    <StyledComponent>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        // TEMPORARY NBC DISPUTE
        // video={videos.soccer.videoUrl}
        // videoMobile={videos.soccer.videoMobileUrl}
        // annotations={videos.soccer.annotations}
        poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
        posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
        title={'The most soccer you can stream'}
        subtitle="Choose between the coverage you want or the price you need"
        networkSet="soccer"
        noteLink="/soccer-es/"
        sportId={sportIds.Soccer}
        hasPlanCards={true}
        plans={[
          { ...usPlanData.pro_soccer_en_monthly, fillImageSpace: true },
          latinoPlanData.latino_soccer_en_monthly,
        ]}
        heroCtaNote={
          <Link to={'/soccer-es/'}>
            Para traducir a español, <span>haga clic aquí</span>.
          </Link>
        }
        caRedirectUrl={'/ca/dazn/'}
      />
    </StyledComponent>
  )
}

const StyledComponent = styled.div`
  .section-content .planCard__image::after {
    background: radial-gradient(ellipse 126% 60% at top right, transparent 50%, rgb(4, 9, 17) 100%);
  }
`
